import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Group, Stack } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';
import { ThemeIcon } from '@folio/components/ui/theme-icon';

type WarningBannerProps = {
  message: string;
  title?: string;
};

export const WarningBanner = ({ message, title }: WarningBannerProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('warningBanner.defaultTitle');
  return (
    <Group align="start" gap={3} className="rounded-xl bg-amber-50 px-4 py-3 shadow-sm">
      <ThemeIcon size="sm" radius="full" variant="filled" tone="warning" className="self-center">
        <AlertTriangle />
      </ThemeIcon>
      <Stack gap={0} className="gap-0.5">
        <Text size="sm" weight="semibold" className="text-amber-700">
          {resolvedTitle}
        </Text>
        <Text size="sm" className="text-amber-600">
          {message}
        </Text>
      </Stack>
    </Group>
  );
};
